import { APP_LANGUAGE } from "../utils/config";
import EN from "./en.json";
import ES from "./es.json";
import UA from "./ua.json";
export const defaultLocale = "EN";
const S3_BASE_URL =  APP_LANGUAGE;
export const localLanguages = {
  EN,
  ES,
  UA,
}
export const languages = {
  EN: {
    url: `${S3_BASE_URL}/en.json`,
    id: "EN",
  },
  ES: {
    url: `${S3_BASE_URL}/es.json`,
    id: "ES",
  },
  UA: {
    url: `${S3_BASE_URL}/ua.json`,
    id: "UA",
  },
};

export const loadLanguageResources = async (locale) => {
  try {
    const language = languages[locale];
    if (!language) throw new Error(`Language ${locale} not supported.`);
    
    const response = await fetch(language.url);
    if (!response.ok) throw new Error("Failed to fetch language resources.");
    
    const resources = await response.json();
    return resources;
  } catch (error) {
    console.error(`Error loading language resources: ${error.message}`);
    return localLanguages[locale]; // fallback from local
  }
};
